import React, { useState, useEffect } from 'react';
import { AlertCircle, X } from 'lucide-react';
import { Button } from './ui/button';
import { trackEvent } from '../seo/analytics';

export const FloatingRoadsideButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling down 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (isDismissed) {
    return null;
  }

  return (
    <>
      {isVisible && (
        <div className="fixed bottom-6 right-6 z-40 animate-fade-in">
          <div className="relative">
            {/* Dismiss button */}
            <button
              onClick={() => setIsDismissed(true)}
              className="absolute -top-2 -right-2 w-6 h-6 bg-gray-900 hover:bg-gray-800 text-white rounded-full flex items-center justify-center shadow-lg z-10"
            >
              <X className="w-4 h-4" />
            </button>

            {/* Main button */}
            <a
              href="/roadside"
              onClick={() =>
                trackEvent('roadside_request_started', {
                  event_category: 'engagement',
                  event_label: 'floating_emergency_help_btn',
                })
              }
            >
              <Button
                size="lg"
                className="bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-white shadow-2xl hover:shadow-3xl transition-all animate-pulse px-6 py-4"
              >
                <AlertCircle className="w-5 h-5 mr-2 animate-spin" style={{ animationDuration: '3s' }} />
                <span className="font-bold">Emergency Help</span>
              </Button>
            </a>
          </div>
        </div>
      )}
    </>
  );
};
